<template><!-- svgo-optimised -->
<svg class="icon icon__chevron icon__chevron--down" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m6.03 9.47.883-.883 5.058 5.058 5.058-5.058.884.884-5.942 5.942z" clip-rule="evenodd"/></svg>
</template>